import axios from "../axios-auth";
import orginal_axios from "axios";

export const stockTransferRequestService = {
    saveStockTransferRequest,
    getStockTransferRequestList,
    getStockTransferRequestDetail,
    getAllStockTransferRequestList,
    printStockTransferRequestById,
    getStockTransferRequestTemplate,
    saveStockTransferRequestExcel,
    exportAllStockTransferRequestExcel
};

function saveStockTransferRequest(stockTransferRequest) {
    if (!stockTransferRequest.id) {
        // new stockTransferRequest
        return axios.post("/auth/stock-transfer-request", stockTransferRequest);
    } else {
        // edit
        return axios.put("/auth/stock-transfer-request", stockTransferRequest);
    }
}

function getStockTransferRequestList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.fromWarehouseId) {
        params["fromWarehouseId"] = searchParams.fromWarehouseId;
    }
    if (searchParams.toWarehouseId) {
        params["toWarehouseId"] = searchParams.toWarehouseId;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    return axios.get("/auth/stock-transfer-request", { params });
}

function getAllStockTransferRequestList(searchParams) {
    let params = {
        sort: "issueDate,asc"
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.fromWarehouseId) {
        params["fromWarehouseId"] = searchParams.fromWarehouseId;
    }
    if (searchParams.toWarehouseId) {
        params["toWarehouseId"] = searchParams.toWarehouseId;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    return axios.get("/auth/stock-transfer-request", { params });
}

function getStockTransferRequestDetail(id) {
    return axios.get("/auth/stock-transfer-request/" + id);
}

function printStockTransferRequestById(id) {
    return orginal_axios({
        url: axios.defaults.baseURL + "/auth/stock-transfer-request-print/" + id,
        method: "GET",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/pdf",
            "Content-Type": "application/json"
        }
    }).then(function (response) {
        return new Blob([response.data], { type: "application/pdf" });
    });
}

function getStockTransferRequestTemplate() {
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-transfer-request-excel-template",
        responseType: "arraybuffer",// important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "applcation/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return {
            blob: new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }), headers: response.headers
        }
    });
}

function saveStockTransferRequestExcel(file) {
    return axios.post('/auth/stock-transfer-request-excel',
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}

function exportAllStockTransferRequestExcel(searchParams) {
    return orginal_axios({
        url: axios.defaults.baseURL + "/auth/stock-transfer-request-header-detail-excel/",
        // url: axios.defaults.baseURL + "/auth/stock-transfer-header-detail-excel/",
        method: "GET",
        responseType: "arraybuffer", // important
        params: {
            fromWarehouseId: searchParams.fromWarehouseId,
            toWarehouseId: searchParams.toWarehouseId,
            fromDate: searchParams.fromDate,
            toDate: searchParams.toDate,
            issueNo: searchParams.issueNo,
            status: searchParams.status,
            updateUserId: searchParams.updateUserId
        },
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}


